import {
  axiosInstance,
  GET_ALL_OVERALL_MATERIALS,
  GET_OVERALL_MATERIAL_BY_ID,
} from "../apiurls/apiurls";

export const getAllOverallMaterials = async (params) => {
  try {
    const response = await axiosInstance.get(GET_ALL_OVERALL_MATERIALS, {
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching all overall materials:", error);
    throw error;
  }
};

export const getOverallMaterialById = async (id) => {
  try {
    const response = await axiosInstance.get(GET_OVERALL_MATERIAL_BY_ID, {
      params: { id },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching overall material by ID:", error);
    throw error;
  }
};
